const { hook: globalHook } = require('js/global/module')

module.exports = function() {
  return {
    $get: [
      function() {
        /* --------------------misc--------------------- */
        // 一些不好分类的工具类方法可以放在这里
        const misc = {
          // 是否生产环境
          isProd: process.env.NODE_ENV.indexOf('production') > -1
        }
        /*
          useage: 基于位的简单多状态管理, 注意状态需为2的1、2、3 ...n 次幂开始定义
            var MOD = $utils.$misc.modManager.createNew({
                "EDIT" : 2,         //编辑状态
                "SEARCH" : 4,       //搜索状态
                "REFRESHING" : 8,   //正在下拉刷新
                "LOADING" : 16      //正在上拉加载更多
            });
            MOD.add(MOD.EDIT).add(MOD.REFRESHING).remove(MOD.SEARCH);
            MOD.contain(MOD.EDIT) == true
            MOD.contain(MOD.SEARCH) == false
            MOD.contain(MOD.REFRESHING) == true
        */
        misc.modManager = (function() {
          return {
            createNew: function(hashObj) {
              let _key = 1
              const _this = this
              this.contain = function(iKey) {
                return (iKey & _key) == iKey
              }
              this.add = function(iKey) {
                _key = iKey | _key
                return _this
              }
              this.remove = function(iKey) {
                _key = _key - (iKey & _key)
                return _this
              }

              for (const i in hashObj) {
                if (hashObj.hasOwnProperty(i)) {
                  this[i] = hashObj[i]
                }
              }
              return this
            }
          }
        }())

        misc.MD = (function mobileDetect() {
          const obj = {}
          // 浏览器版本判断
          obj.UA = navigator.userAgent
          obj.isDingTalk = isDingTalk(obj.UA)
          obj.isWeChat = isWeChat(obj.UA)
          obj.isWorkWeChat = /wxwork/gi.test(obj.UA)
          obj.isKingDee = isKingDee(obj.UA)
          obj.isQQBrowser = isQQBrowser(obj.UA)
          obj.isAppEmbed = isAppEmbed(obj.UA)
          return obj
        }())

        function isQQBrowser(ua) {
          return /mqqbrowser/gi.test(ua)
        }
        function isWeChat(ua) {
          return /MicroMessenger/gi.test(ua)
        }
        function isDingTalk(ua) {
          return /dingtalk/gi.test(ua)
        }
        function isAppEmbed(ua) {
          return globalHook.has('isAppEmbed') ? globalHook.call('isAppEmbed') : (
            isDingTalk(ua) || isWeChat(ua) || isKingDee(ua) || /hxphone/gi.test(ua)
          )
        }
        /*
          金蝶云之家APP(云之家Private) User-Agent样例:

          华润iOS：
          User-Agent: Qing/0.9.6;iPhone OS 10.2;Apple;iPad4,4;deviceId:5b6012e783c808d7070af5e45c13b065;
          deviceName:Qa%E7%9A%84%20iPad;clientId:10200;os:iPhone OS 10.2;projectCode:crland;
          xtUrl:http://im.crland.com.cn:6007/;brand:Apple;model:iPad4,4;Mozilla/5.0 (iPhone;
          CPU iPhone OS 10_2 like Mac OS X) AppleWebKit/602.3.12 (KHTML, like Gecko) Mobile/14C92

          海信iOS：
          User-Agent: Qing/0.9.9;iPhone OS 9.3;Apple;x86_64;deviceId:f7b164f451b22468aa88aa0754c803b8;
          deviceName:;clientId:10200;os:iPhone OS 9.3;projectCode:kaifa;xtUrl:https://im.hisense.com/;
          brand:Apple;model:x86_64;Mozilla/5.0 (iPhone; CPU iPhone OS 9_3 like Mac OS X) AppleWebKit/
          601.1.46 (KHTML, like Gecko) Mobile/13E230

          海信Android:
          User-Agent: Qing/0.9.9;Android 6.0.1;OPPO;projectCode:hisense;xtUrl:https://im.hisense.com;OPPO A57
          ;Mozilla/5.0 (Linux; Android 6.0.1; OPPO A57 Build/MMB29M; wv) AppleWebKit/537.36 (KHTML
          , like Gecko) Version/4.0 Chrome/46.0.2490.76 Mobile Safari/537.36

          立白iOS:
          User-Agent: Qing/0.9.63;iOS 11.2.2;Apple;iPhone9,1;deviceId:fff17b4c-0fef-4dba-ad69-fe741861a47a;
          deviceName:iPhone;clientId:10246;os:iOS 11.2.2;brand:Apple;model:iOS9,1;oem:kysun;
          Mozilla/5.0 (iPhone; CPU iPhone OS 11_2_2 like Mac OS X) AppleWebKit/604.4.7 (KHTML, like Gecko) Mobile/15C202
        */
        function isKingDee(ua) {
          return /Qing/gi.test(ua)
        }

        // hxphone-sub子模块的一些公共属性和方法
        misc.subModule = (function () {
          const origin = process.env.SUB_MODULE_ORIGIN
          const srcPrefix = origin + (misc.isProd ? './app' : '')
          return {
            origin,
            scheduleSrc: `${srcPrefix}/schedule.html`,
            cloudStorageSrc: `${srcPrefix}/cloudStorage.html`,
            getPostMsgOrigin: (prodOrigin) => (misc.isProd ? prodOrigin : origin)
          }
        })()

        return misc
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/js/infrastructure/utils/misc.js